import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

function OrderFlowResellerIncome() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showSample, setShowSample] = useState(false);
  const [searchProduct, setSearchProduct] = useState("");
  const [searchSeller, setSearchSeller] = useState("");
  const [searchBuyer, setSearchBuyer] = useState("");
  const [searchDate, setSearchDate] = useState("");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const dummyData = [
    { sn: 1, product: "Handmade Silk Scarf", seller: "Anita Sharma", buyer: "Priya Patel", date: "2025-11-01", amount: 500, commission: 75 },
    { sn: 2, product: "Organic Herbal Tea", seller: "Ritu Devi", buyer: "Suresh Kumar", date: "2025-11-02", amount: 250, commission: 50 },
    { sn: 3, product: "Eco-Friendly Tote Bag", seller: "Meera Singh", buyer: "Neha Gupta", date: "2025-11-03", amount: 300, commission: 30 },
    { sn: 4, product: "Handcrafted Jewelry Set", seller: "Anita Sharma", buyer: "Rajesh Verma", date: "2025-11-04", amount: 750, commission: 188 },
    { sn: 5, product: "Natural Skincare Cream", seller: "Lata Bai", buyer: "Priya Patel", date: "2025-11-05", amount: 400, commission: 32 },
    { sn: 6, product: "Spiced Pickle Jar", seller: "Ritu Devi", buyer: "Amit Joshi", date: "2025-11-06", amount: 150, commission: 18 },
    { sn: 7, product: "Bamboo Toothbrush Pack", seller: "Meera Singh", buyer: "Sita Devi", date: "2025-11-07", amount: 100, commission: 30 },
    { sn: 8, product: "Aromatherapy Candles", seller: "Anita Sharma", buyer: "Neha Gupta", date: "2025-11-08", amount: 600, commission: 30 },
    { sn: 9, product: "Handwoven Basket", seller: "Lata Bai", buyer: "Rajesh Verma", date: "2025-11-09", amount: 350, commission: 63 },
    { sn: 10, product: "Traditional Saree", seller: "Ritu Devi", buyer: "Priya Patel", date: "2025-11-10", amount: 1200, commission: 264 },
  ];

  const filteredData = dummyData.filter((row) => 
    row.product.toLowerCase().includes(searchProduct.toLowerCase()) &&
    row.seller.toLowerCase().includes(searchSeller.toLowerCase()) &&
    row.buyer.toLowerCase().includes(searchBuyer.toLowerCase()) &&
    row.date.includes(searchDate)
  );

  const totalCommission = filteredData.reduce((sum, row) => sum + row.commission, 0);
  const recordCount = filteredData.length;

  if (!showSample) {
    return (
      <div className="min-h-screen bg-black">
        <div className="min-h-screen flex flex-col bg-[#0a192f] text-blue-100 font-sans">
          {/* Header */}
          <header className="sticky top-0 z-50 bg-[#1e3a8a] border-b border-blue-900 px-4 py-2 flex items-center justify-between shadow-lg">
            <div className="flex flex-col">
              <div className="text-xl lg:text-2xl font-bold text-blue-400">💙 OrderFlow Reseller</div>
              <div className="text-[10px] lg:text-lg text-cyan-200">
                My Reseller Income
              </div>
            </div>

            {/* Desktop user controls */}
            <div className="hidden md:flex items-center gap-3">
              {isLoggedIn ? (
                <>
                  <div className="text-xs text-left text-blue-300">{userName}</div>
                  <button
                    onClick={handleLogout}
                    className="p-2 mt-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => navigate("/login")}
                    className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => navigate("/signup")}
                    className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
                  >
                    Register
                  </button>
                </>
              )}
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setIsMobileMenuOpen((s) => !s)}
              className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? "×" : "☰"}
            </button>
          </header>

          {/* Mobile menu content */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-[#1e3a8a] border-b border-blue-900 px-4 py-2 animate-fadeIn">
              {isLoggedIn ? (
                <div className="flex flex-row items-center justify-center gap-3">
                  <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                    Welcome, {userName}
                  </span>
                  <button
                    onClick={handleLogout}
                    className="rounded-md bg-red-600 hover:bg-red-700 w-7 h-7 flex items-center justify-center text-white"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </div>
              ) : (
                <div className="flex flex-row items-center justify-center gap-6">
                  <Link to="/login" className="text-blue-300 hover:text-cyan-300">
                    Login
                  </Link>
                  <span className="text-blue-500">|</span>
                  <Link to="/signup" className="text-blue-300 hover:text-cyan-300">
                    Register
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* Main Content */}
          <main className="flex-1 py-8 px-4 text-center">
            <div className="max-w-md mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-blue-400 mb-6">
                Reseller Income Dashboard
              </h1>
              <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
                You have not started your reseller journey yet! Click Explore How My Income Will Look Like button below to see a sample income inf.
              </p>
              <button
                onClick={() => setShowSample(true)}
                className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-3 px-8 rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition w-full sm:w-auto"
              >
                Explore How My Income Will Look Like
              </button>
            </div>
          </main>

          {/* Footer */}
          <footer className="bg-[#1e3a8a] border-t border-blue-900 text-blue-300 py-4 mt-auto">
            <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
              <div className="text-xs lg:text-sm">
                © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
              </div>
              <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <div className="min-h-screen flex flex-col bg-[#0a192f] text-blue-100 font-sans">
        {/* Header */}
        <header className="sticky top-0 z-50 bg-[#1e3a8a] border-b border-blue-900 px-4 py-2 flex items-center justify-between shadow-lg">
          <div className="flex flex-col">
            <div className="text-xl lg:text-2xl font-bold text-blue-400">💙 OrderFlow Reseller</div>
            <div className="text-[10px] lg:text-lg text-cyan-200">
              My Reseller Income
            </div>
          </div>

          {/* Desktop user controls */}
          <div className="hidden md:flex items-center gap-3">
            {isLoggedIn ? (
              <>
                <div className="text-xs text-left text-blue-300">{userName}</div>
                <button
                  onClick={handleLogout}
                  className="p-2 mt-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                >
                  Login
                </button>
                <button
                  onClick={() => navigate("/signup")}
                  className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
                >
                  Register
                </button>
              </>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </header>

        {/* Mobile menu content */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#1e3a8a] border-b border-blue-900 px-4 py-2 animate-fadeIn">
            {isLoggedIn ? (
              <div className="flex flex-row items-center justify-center gap-3">
                <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                  Welcome, {userName}
                </span>
                <button
                  onClick={handleLogout}
                  className="rounded-md bg-red-600 hover:bg-red-700 w-7 h-7 flex items-center justify-center text-white"
                  title="Logout"
                >
                  ⏻
                </button>
              </div>
            ) : (
              <div className="flex flex-row items-center justify-center gap-6">
                <Link to="/login" className="text-blue-300 hover:text-cyan-300">
                  Login
                </Link>
                <span className="text-blue-500">|</span>
                <Link to="/signup" className="text-blue-300 hover:text-cyan-300">
                  Register
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Main Content */}
        <main className="flex-1 py-6 px-4">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold text-blue-400 mb-6 text-center">
              Sample Reseller Income Records
            </h1>

            {/* Search Inputs */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <input
                type="text"
                placeholder="Search Product..."
                value={searchProduct}
                onChange={(e) => setSearchProduct(e.target.value)}
                className="bg-gray-800 text-blue-100 px-3 py-2 rounded-lg border border-blue-500 focus:outline-none focus:border-blue-400"
              />
              <input
                type="text"
                placeholder="Search Seller Name..."
                value={searchSeller}
                onChange={(e) => setSearchSeller(e.target.value)}
                className="bg-gray-800 text-blue-100 px-3 py-2 rounded-lg border border-blue-500 focus:outline-none focus:border-blue-400"
              />
              <input
                type="text"
                placeholder="Search Buyer Name..."
                value={searchBuyer}
                onChange={(e) => setSearchBuyer(e.target.value)}
                className="bg-gray-800 text-blue-100 px-3 py-2 rounded-lg border border-blue-500 focus:outline-none focus:border-blue-400"
              />
              <input
                type="date"
                placeholder="Search Date..."
                value={searchDate}
                onChange={(e) => setSearchDate(e.target.value)}
                className="bg-gray-800 text-blue-100 px-3 py-2 rounded-lg border border-blue-500 focus:outline-none focus:border-blue-400"
              />
            </div>

            {/* Totals */}
            <div className="bg-gray-800 rounded-lg p-4 mb-6 text-center">
              <p className="text-blue-400 font-semibold">
                Total Records: {recordCount} | Total Commission: ₹{totalCommission.toLocaleString()}
              </p>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-blue-500 bg-gray-800 rounded-lg">
                <thead>
                  <tr className="bg-blue-900">
                    <th className="border border-blue-500 p-3 text-left text-blue-200">SN</th>
                    <th className="border border-blue-500 p-3 text-left text-blue-200">Product Name</th>
                    <th className="border border-blue-500 p-3 text-left text-blue-200">Seller Name</th>
                    <th className="border border-blue-500 p-3 text-left text-blue-200">Buyer Name</th>
                    <th className="border border-blue-500 p-3 text-left text-blue-200">Date</th>
                    <th className="border border-blue-500 p-3 text-left text-blue-200">Amount (₹)</th>
                    <th className="border border-blue-500 p-3 text-left text-blue-200">Commission (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row) => (
                    <tr key={row.sn} className="hover:bg-gray-700 transition">
                      <td className="border border-blue-500 p-3">{row.sn}</td>
                      <td className="border border-blue-500 p-3">{row.product}</td>
                      <td className="border border-blue-500 p-3">{row.seller}</td>
                      <td className="border border-blue-500 p-3">{row.buyer}</td>
                      <td className="border border-blue-500 p-3">{row.date}</td>
                      <td className="border border-blue-500 p-3">₹{row.amount.toLocaleString()}</td>
                      <td className="border border-blue-500 p-3 font-semibold text-green-400">₹{row.commission.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#1e3a8a] border-t border-blue-900 text-blue-300 py-4 mt-auto">
          <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm">
              © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
              <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default OrderFlowResellerIncome;